import { render, staticRenderFns } from "./our-group.vue?vue&type=template&id=7d51055f&"
import script from "./our-group.vue?vue&type=script&lang=js&"
export * from "./our-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports